import { render, staticRenderFns } from "./ConfigAnalyzer.vue?vue&type=template&id=51766af6&scoped=true"
import script from "./ConfigAnalyzer.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigAnalyzer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ConfigAnalyzer.vue?vue&type=style&index=0&id=51766af6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51766af6",
  null
  
)

export default component.exports